/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContractorRouteRouteImport } from './routes/_contractor/route'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContractorTenantSlugRouteRouteImport } from './routes/_contractor/$tenantSlug/route'
import { Route as ContractorTeamRouteRouteImport } from './routes/_contractor/team/route'
import { Route as ContractorTenantSlugIndexRouteImport } from './routes/_contractor/$tenantSlug/index'
import { Route as ContractorQuotesIndexRouteImport } from './routes/_contractor/quotes/index'
import { Route as ContractorTeamIndexRouteImport } from './routes/_contractor/team/index'
import { Route as ContractorTeamUserIdRouteImport } from './routes/_contractor/team/$userId'
import { Route as ContractorTenantSlugQuotesIndexRouteImport } from './routes/_contractor/$tenantSlug/quotes/index'
import { Route as ContractorTenantSlugQuotesQuoteNumberRouteImport } from './routes/_contractor/$tenantSlug/quotes/$quoteNumber'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorRouteRoute = ContractorRouteRouteImport.update({
  id: '/_contractor',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorTenantSlugRouteRoute =
  ContractorTenantSlugRouteRouteImport.update({
    id: '/$tenantSlug',
    path: '/$tenantSlug',
    getParentRoute: () => ContractorRouteRoute,
  } as any)
const ContractorTeamRouteRoute = ContractorTeamRouteRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => ContractorRouteRoute,
} as any)
const ContractorTenantSlugIndexRoute =
  ContractorTenantSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContractorTenantSlugRouteRoute,
  } as any)
const ContractorQuotesIndexRoute = ContractorQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => ContractorRouteRoute,
} as any)
const ContractorTeamIndexRoute = ContractorTeamIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContractorTeamRouteRoute,
} as any)
const ContractorTeamUserIdRoute = ContractorTeamUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => ContractorTeamRouteRoute,
} as any)
const ContractorTenantSlugQuotesIndexRoute =
  ContractorTenantSlugQuotesIndexRouteImport.update({
    id: '/quotes/',
    path: '/quotes/',
    getParentRoute: () => ContractorTenantSlugRouteRoute,
  } as any)
const ContractorTenantSlugQuotesQuoteNumberRoute =
  ContractorTenantSlugQuotesQuoteNumberRouteImport.update({
    id: '/quotes/$quoteNumber',
    path: '/quotes/$quoteNumber',
    getParentRoute: () => ContractorTenantSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/$tenantSlug': typeof ContractorTenantSlugRouteRouteWithChildren
  '/team': typeof ContractorTeamRouteRouteWithChildren
  '/team/$userId': typeof ContractorTeamUserIdRoute
  '/$tenantSlug/': typeof ContractorTenantSlugIndexRoute
  '/quotes/': typeof ContractorQuotesIndexRoute
  '/team/': typeof ContractorTeamIndexRoute
  '/$tenantSlug/quotes/$quoteNumber': typeof ContractorTenantSlugQuotesQuoteNumberRoute
  '/$tenantSlug/quotes/': typeof ContractorTenantSlugQuotesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/team/$userId': typeof ContractorTeamUserIdRoute
  '/$tenantSlug': typeof ContractorTenantSlugIndexRoute
  '/quotes': typeof ContractorQuotesIndexRoute
  '/team': typeof ContractorTeamIndexRoute
  '/$tenantSlug/quotes/$quoteNumber': typeof ContractorTenantSlugQuotesQuoteNumberRoute
  '/$tenantSlug/quotes': typeof ContractorTenantSlugQuotesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_contractor': typeof ContractorRouteRouteWithChildren
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/_contractor/$tenantSlug': typeof ContractorTenantSlugRouteRouteWithChildren
  '/_contractor/team': typeof ContractorTeamRouteRouteWithChildren
  '/_contractor/team/$userId': typeof ContractorTeamUserIdRoute
  '/_contractor/$tenantSlug/': typeof ContractorTenantSlugIndexRoute
  '/_contractor/quotes/': typeof ContractorQuotesIndexRoute
  '/_contractor/team/': typeof ContractorTeamIndexRoute
  '/_contractor/$tenantSlug/quotes/$quoteNumber': typeof ContractorTenantSlugQuotesQuoteNumberRoute
  '/_contractor/$tenantSlug/quotes/': typeof ContractorTenantSlugQuotesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invite'
    | '/login'
    | '/$tenantSlug'
    | '/team'
    | '/team/$userId'
    | '/$tenantSlug/'
    | '/quotes/'
    | '/team/'
    | '/$tenantSlug/quotes/$quoteNumber'
    | '/$tenantSlug/quotes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invite'
    | '/login'
    | '/team/$userId'
    | '/$tenantSlug'
    | '/quotes'
    | '/team'
    | '/$tenantSlug/quotes/$quoteNumber'
    | '/$tenantSlug/quotes'
  id:
    | '__root__'
    | '/'
    | '/_contractor'
    | '/invite'
    | '/login'
    | '/_contractor/$tenantSlug'
    | '/_contractor/team'
    | '/_contractor/team/$userId'
    | '/_contractor/$tenantSlug/'
    | '/_contractor/quotes/'
    | '/_contractor/team/'
    | '/_contractor/$tenantSlug/quotes/$quoteNumber'
    | '/_contractor/$tenantSlug/quotes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContractorRouteRoute: typeof ContractorRouteRouteWithChildren
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_contractor': {
      id: '/_contractor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ContractorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_contractor/$tenantSlug': {
      id: '/_contractor/$tenantSlug'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof ContractorTenantSlugRouteRouteImport
      parentRoute: typeof ContractorRouteRoute
    }
    '/_contractor/team': {
      id: '/_contractor/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof ContractorTeamRouteRouteImport
      parentRoute: typeof ContractorRouteRoute
    }
    '/_contractor/$tenantSlug/': {
      id: '/_contractor/$tenantSlug/'
      path: '/'
      fullPath: '/$tenantSlug/'
      preLoaderRoute: typeof ContractorTenantSlugIndexRouteImport
      parentRoute: typeof ContractorTenantSlugRouteRoute
    }
    '/_contractor/quotes/': {
      id: '/_contractor/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof ContractorQuotesIndexRouteImport
      parentRoute: typeof ContractorRouteRoute
    }
    '/_contractor/team/': {
      id: '/_contractor/team/'
      path: '/'
      fullPath: '/team/'
      preLoaderRoute: typeof ContractorTeamIndexRouteImport
      parentRoute: typeof ContractorTeamRouteRoute
    }
    '/_contractor/team/$userId': {
      id: '/_contractor/team/$userId'
      path: '/$userId'
      fullPath: '/team/$userId'
      preLoaderRoute: typeof ContractorTeamUserIdRouteImport
      parentRoute: typeof ContractorTeamRouteRoute
    }
    '/_contractor/$tenantSlug/quotes/': {
      id: '/_contractor/$tenantSlug/quotes/'
      path: '/quotes'
      fullPath: '/$tenantSlug/quotes/'
      preLoaderRoute: typeof ContractorTenantSlugQuotesIndexRouteImport
      parentRoute: typeof ContractorTenantSlugRouteRoute
    }
    '/_contractor/$tenantSlug/quotes/$quoteNumber': {
      id: '/_contractor/$tenantSlug/quotes/$quoteNumber'
      path: '/quotes/$quoteNumber'
      fullPath: '/$tenantSlug/quotes/$quoteNumber'
      preLoaderRoute: typeof ContractorTenantSlugQuotesQuoteNumberRouteImport
      parentRoute: typeof ContractorTenantSlugRouteRoute
    }
  }
}

interface ContractorTenantSlugRouteRouteChildren {
  ContractorTenantSlugIndexRoute: typeof ContractorTenantSlugIndexRoute
  ContractorTenantSlugQuotesQuoteNumberRoute: typeof ContractorTenantSlugQuotesQuoteNumberRoute
  ContractorTenantSlugQuotesIndexRoute: typeof ContractorTenantSlugQuotesIndexRoute
}

const ContractorTenantSlugRouteRouteChildren: ContractorTenantSlugRouteRouteChildren =
  {
    ContractorTenantSlugIndexRoute: ContractorTenantSlugIndexRoute,
    ContractorTenantSlugQuotesQuoteNumberRoute:
      ContractorTenantSlugQuotesQuoteNumberRoute,
    ContractorTenantSlugQuotesIndexRoute: ContractorTenantSlugQuotesIndexRoute,
  }

const ContractorTenantSlugRouteRouteWithChildren =
  ContractorTenantSlugRouteRoute._addFileChildren(
    ContractorTenantSlugRouteRouteChildren,
  )

interface ContractorTeamRouteRouteChildren {
  ContractorTeamUserIdRoute: typeof ContractorTeamUserIdRoute
  ContractorTeamIndexRoute: typeof ContractorTeamIndexRoute
}

const ContractorTeamRouteRouteChildren: ContractorTeamRouteRouteChildren = {
  ContractorTeamUserIdRoute: ContractorTeamUserIdRoute,
  ContractorTeamIndexRoute: ContractorTeamIndexRoute,
}

const ContractorTeamRouteRouteWithChildren =
  ContractorTeamRouteRoute._addFileChildren(ContractorTeamRouteRouteChildren)

interface ContractorRouteRouteChildren {
  ContractorTenantSlugRouteRoute: typeof ContractorTenantSlugRouteRouteWithChildren
  ContractorTeamRouteRoute: typeof ContractorTeamRouteRouteWithChildren
  ContractorQuotesIndexRoute: typeof ContractorQuotesIndexRoute
}

const ContractorRouteRouteChildren: ContractorRouteRouteChildren = {
  ContractorTenantSlugRouteRoute: ContractorTenantSlugRouteRouteWithChildren,
  ContractorTeamRouteRoute: ContractorTeamRouteRouteWithChildren,
  ContractorQuotesIndexRoute: ContractorQuotesIndexRoute,
}

const ContractorRouteRouteWithChildren = ContractorRouteRoute._addFileChildren(
  ContractorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContractorRouteRoute: ContractorRouteRouteWithChildren,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
